import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import copyToClipboard from "copy-to-clipboard";
import classnames from "classnames";
import { NO_OP } from "utils/action";
import HoverIconButton from "components/HoverIconButton";

const DEFAULT_CLASSES = {
  container:
    "bg-white w-100 truncate flex flex-row items-center justify-between",
  hasValue: "br4 hairline-1 pv1 pl3 pr2 ba ml2 bg-white--hover pointer",
  button:
    "ma0 items-center flex pa1 dib items-center justify-center bn br1 panel--action relative bg-white bg-content--secondary bg-content--hover",
  link:
    "f7 f6-ns link color-primary truncate fw5 link__decoration--hover w-100",
  placeholder: "f7 f6-ns truncate"
};

const CopyURL = ({ copy, href, placeholder, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const { addToast } = useToasts();
  const [_, setClipboard] = useState("");
  const copyUrl = () => {
    setClipboard(href);
    copyToClipboard(href);
    addToast("Copied URL", {
      appearance: "info",
      autoDismiss: true
    });
  };
  const hrefVal = copy || href;
  const hrefLink = hrefVal ? (
    <a target="_blank" className={classes.link} href={href}>
      {hrefVal.trim()}
    </a>
  ) : null;

  let content = null;
  if (href) {
    content = hrefLink;
  } else if (placeholder) {
    content = <div className={classes.placeholder}>{placeholder}</div>;
  }

  const hasValue = href || placeholder;
  return (
    <div
      onClick={href ? copyUrl : NO_OP}
      className={classnames(classes.container, {
        [classes.hasValue]: hasValue
      })}
    >
      {content}
      {href && (
        <HoverIconButton
          size={14}
          type="copy"
          tooltip="Copy link"
          customClasses={{
            button: classes.button
          }}
        />
      )}
    </div>
  );
};

export default CopyURL;
